import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: {
    hasError: false,
    status: null,
    message: null,
    type: 'errorBoundary',
  },
  alert: {
    visible: false,
    type: '',
    messages: [],
  },
  notification: {
    visible: false,
    type: '',
    title: '',
    children: '',
  },
};

const reducers = {
  setError: (state, action) => {
    const data = action.payload;
    for (const [key, value] of Object.entries(data)) {
      // check if key exists in state
      if (key in state.error) {
        state.error[key] = value;
      }
    }
  },
  setAlert: (state, action) => {
    const data = action.payload;
    for (const [key, value] of Object.entries(data)) {
      // check if key exists in state
      if (key in state.alert) {
        state.alert[key] = value;
      }
    }
  },
  setNotification: (state, action) => {
    const data = action.payload;
    for (const [key, value] of Object.entries(data)) {
      // check if key exists in state
      if (key in state.notification) {
        state.notification[key] = value;
      }
    }
  },
};

const slice = createSlice({
  name: 'general',
  initialState,
  reducers,
});

export const { setError, setAlert, setNotification } = slice.actions;

export default slice.reducer;
